export default __webpack_public_path__ + "static/media/Bloodcarve.6760955d.jpg";